import type { X4bLocation } from '@/modules/concierge/views/PlacesRepository';
import { DeliveryItemType, DeliverySize } from '@/modules/vehicle/engine/ActivityTypes';
import type { XpressVehicleType } from '@/modules/vehicle/engine/VehicleType';

export { DeliveryItemType, DeliverySize };

/** Delivery payer cards in New Send Booking (UI only; orders are always company-billed on the server). */
export type DeliveryPayerOption = 'x4b' | 'cash_sender' | 'cash_recipient';

export const DELIVERY_PAYERS_SELECTABLE: ReadonlyArray<DeliveryPayerOption> = ['x4b'];

export function isDeliveryPayerSelectable(option: DeliveryPayerOption): boolean {
	return DELIVERY_PAYERS_SELECTABLE.includes(option);
}

export type NewSendBookingStep1Values = {
	senderContactName: string;
	senderPhone: string;
	senderMobileNumberPrefix: string;
	pickUpAddress: X4bLocation | undefined;
	recipientContactName: string;
	recipientPhone: string;
	recipientMobileNumberPrefix: string;
	dropOffAddress: X4bLocation | undefined;
};

export const DELIVERY_WEIGHT_MAX_KG_OPTIONS = [1, 5, 10, 20] as const;

export type NewSendBookingFormValues = NewSendBookingStep1Values & {
	deliveryItemType: DeliveryItemType;
	parcelSize: DeliverySize;
	weightMaxKg: number;
	driverNotes: string;
	payer: DeliveryPayerOption;
};

/**
 * Prefill payload passed via router state when booking a return for a delivery order.
 * Sender/recipient and pickup/dropoff are already swapped by the mapper. The parcel
 * photo cannot be carried over (it is a File), so the user must re-upload it.
 */
export type ReturnSendBookingType = {
	senderContactName: string;
	senderPhone: string;
	senderMobileNumberPrefix: string;
	pickUpAddress?: X4bLocation;
	recipientContactName: string;
	recipientPhone: string;
	recipientMobileNumberPrefix: string;
	dropOffAddress?: X4bLocation;
	deliveryItemType?: DeliveryItemType;
	parcelSize?: DeliverySize;
	weightMaxKg?: number;
	driverNotes?: string;
	vehicleType?: XpressVehicleType;
};
